module.exports = __webpack_public_path__ + "static/media/teams copy.de62b3fe.svg";